// extracted by mini-css-extract-plugin
export default {"root":"IconMapMarker_root__Frv-x"};